import React from 'react'
import { useNavigate } from 'react-router-dom'


export const BackButton = () => {
    const navigate = useNavigate();

    const goBack = () => navigate(-1)

    return (
        <button
            onClick={goBack}
            className="icon-btn page__icon-btn page__icon-btn_left icon-btn_back" />
    )
}